const seatStatsUrl = (businessId: MaybeRefOrGetter<string>) =>
  `/api/businesses/${toValue(businessId)}/seat-stats` as const

export default function useSeatStats(businessId: MaybeRefOrGetter<string>) {
  const { isFreeSignerSeatsFlag } = useReleaseFlags()

  const {
    data: seatStats,
    pending: isLoading,
    refresh,
  } = useLazyApi(() => seatStatsUrl(businessId), { immediate: isFreeSignerSeatsFlag.value })

  return {
    seatStats,
    isLoading,
    refresh: async () => {
      if (isFreeSignerSeatsFlag.value) await refresh()
    },
  }
}

export function useSeatStatsFetch(businessId: MaybeRefOrGetter<string>) {
  const { $api } = useNuxtApp()

  return { fetchSeatStats: () => $api(seatStatsUrl(businessId)) }
}
